// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Images_wrapper__9HtJ_","dimmed":"Images_dimmed__F43aC","status":"Images_status__Lz__V","indicator":"Images_indicator__rsWLl"};